import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ShellService {
  readonly loadMFE: string[] = [];
  headerStatusSubject = new BehaviorSubject<any>(false);
}